document.addEventListener('DOMContentLoaded', function (e) {
  const notification = e.target.querySelector('.part-notification')
  if (notification) {
    const notificationClose = notification.querySelector(
      '.js-close-notification'
    )
    if (notificationClose) {
      notificationClose.addEventListener('click', function () {
        notification.style.display = 'none'
      })
    }
  }
})
